module.exports = __webpack_public_path__ + "static/media/bliksem.1da3caf7.png";